module.exports = __webpack_public_path__ + "img/topic-classification.6911dc80.svg";